import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Contact } from '../state-man/models/contact.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }
  
  // version: the one that came with the list already held, or '' for none.
  public async getAll (version: string) : Promise<{ version: string, rows: Contact[] | null } | null> {      
    try {
      const ret = await this.apiService.getVersionedList('contact/active/', version)
      return ret && { version: ret.version, rows: ret.rows && Contact.buildMany(ret.rows) }
    } 
    catch (error) {    
      LoggerService.log(error + 'contact/active')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
      return null
    }
  }  

}
